/**
 * Created by Ning Jiang on 12/11/2017.
 */

import {
    IStillImageBackgroundConfig,
    StillImageBackground
} from "@nolimitcity/slot-game/bin/game/background/StillImageBackground";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {WildNudgeGameConfig} from "../WildNudgeGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {GameMode, IGameModeChangedData} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {TweenLite} from "gsap";

export class WildNudgeBackground extends StillImageBackground {

    private _fsBackground:PIXI.Sprite;

    private _foregroundLayer:PIXI.Container;
    private _foregroundSprite:PIXI.Sprite;

    private _reelBgLayer:PIXI.Container;
    private _reelBgSprite:PIXI.Sprite;

    private _redOverlayLayer:PIXI.Container;
    private _redOverlay:PIXI.Sprite;

    constructor(config:IStillImageBackgroundConfig) {
        super(config);

        this._redOverlayLayer = StageManager.getLayer(WildNudgeGameConfig.instance.LAYERS.RED_OVERLAY.name);
        this._foregroundLayer = StageManager.getLayer(WildNudgeGameConfig.instance.LAYERS.FOREGROUND.name);
        this._reelBgLayer = StageManager.getLayer(WildNudgeGameConfig.instance.LAYERS.REEL_BACKGROUND.name);
    }

    protected initAnimations():void {
        super.initAnimations();

        this._fsBackground = new PIXI.Sprite(GameResources.getTextures("freespinBackground")[0]);
        this._fsBackground.visible = false;
        this.addChild(this._fsBackground);

        this._foregroundSprite = new PIXI.Sprite(GameResources.getTextures("machine")[0]);
        this._foregroundSprite.position.set(52, -161);
        this._foregroundLayer.addChild(this._foregroundSprite);

        this._reelBgSprite = new PIXI.Sprite(GameResources.getTextures("reelBg")[0]);
        this._reelBgSprite.position.set(232, 69);
        this._reelBgLayer.addChild(this._reelBgSprite);

        this._redOverlay = new PIXI.Sprite(GameResources.getTextures("redOverlay")[0]);
        this._redOverlay.blendMode = PIXI.BLEND_MODES.SCREEN;
        this._redOverlay.position.set(-201, -653);
        this._redOverlay.alpha = 0;
        this._redOverlay.visible = false;
        this._redOverlayLayer.addChild(this._redOverlay);
    }

    protected onChangeBackground(data:IGameModeChangedData):boolean {
        if(!super.onChangeBackground(data)) {
            return false;
        }

        const offset:PIXI.Point = this._backgroundImages[this._currentMode].offset!;
        this._fsBackground.position.set(offset.x, offset.y);

        if(this._currentMode === GameMode.FREESPIN) {
            TweenLite.fromTo(this._fsBackground, 0.2,
                {alpha : 0},
                {
                    alpha : 1, onStart : () => {
                        this._fsBackground.visible = true;
                    }
                });
            TweenLite.to(this._redOverlay, 0.2, {
                alpha : 0.5, onStart : () => {
                    this._redOverlay.visible = true;
                }
            });
        } else {
            TweenLite.to(this._fsBackground, 0.2,
                {
                    alpha : 0, onComplete : () => {
                        this._fsBackground.visible = false;
                    }
                });
            TweenLite.to(this._redOverlay, 0.1, {
                alpha : 0, onComplete : () => {
                    this._redOverlay.visible = false;
                }
            });
        }

        return true
    }
}